import { render } from "./Popup.vue?vue&type=template&id=1b54de86&scoped=true"
import script from "./Popup.vue?vue&type=script&lang=js"
export * from "./Popup.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1b54de86"

export default script